export default __webpack_public_path__ + "static/media/instagram.76429ef9.jpg";